import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { LOCALES } from '@finder/shared/constants/app.constants';
import { GET_SIMPLE_DATE_FROM_DATE_OBJECT, GetSimpleDateFromDateObjectProvider } from '@finder/shared/utils/date/getSimpleDateFromDateObject';

@Injectable({
    providedIn: 'root'
})
export class SsrService {
    private renderingOnTheServer = false;
    private showSpinner = false;
    private dataKey = makeStateKey<boolean>('renderedOnServer');
    private createdDateKey = makeStateKey<string>('date the page was rendered');

    constructor(
        private tranferState: TransferState,
        @Inject(PLATFORM_ID) private platformId: object,
        @Inject(GET_SIMPLE_DATE_FROM_DATE_OBJECT) private getSimpleDateFromDateObject: GetSimpleDateFromDateObjectProvider,
    ) {
        this.renderingOnTheServer = isPlatformServer(this.platformId);

        // If the data is rendered on the server then update the transfer state
        if (this.renderingOnTheServer) {
            this.tranferState.set(this.dataKey, true);
            this.tranferState.set(this.createdDateKey, this.getSimpleDateFromDateObject(new Date(), LOCALES.en_US_normalized));
        }
    }

    isSSR(): boolean {
        /**
         * Is the page CURRENTLY being rendered on the server
         */
        return this.renderingOnTheServer;
    }

    isDataFromTheServer(): boolean {
        /**
         * WAS the page rendered on the server.
         *
         * We need this method to check if the page being served was
         * rendered on the server. This is different from checking if
         * the page is currently being rendered on the server.
         *
         * When we serve this from cache we want to know if the data already
         * exists within the page.
         */
        return this.tranferState.get(this.dataKey, false);
    }

    allowLoadingSpinner() {
        /**
         * This is called when a list page renders
         */
        this.showSpinner = true;
    }

    showLoadingSpinner(): boolean {
        /**
         * If the data isn't from the server allow the spinner to show
         */
        if (!this.isDataFromTheServer()) {
            return true;
        }

        /**
         * By default we shouldn't show the loading spinner. That's only for pages built
         * in the browser or transitioning from a list => detail page.
         */
        return this.isDataFromTheServer() && this.showSpinner;
    }

    getCreatedDate(): string {
        /**
         * Get the date this snapshot was taken. Use the date to select a new
         * schedule if needed
         */
        return this.tranferState.get(this.createdDateKey, void 0);
    }
}
